import { toggleScroll } from '@/utils/scrollControl.js';

export default {
  showModal({ commit }, value) {
    toggleScroll(value);
    commit("setShowModal", value);
  },
  showModalDraft({ commit }, value) {
    commit("setShowModalDraft", value);
  },
  showModalAboutUs({ commit }, value) {
    toggleScroll(value);
    commit("setShowModalAboutUs", value);
  },
  showModalReply({ commit }, value) {   
    toggleScroll(value);
    commit("setShowModalReply", value);
  },
  addModalDataToState({ commit }, payload) {    
    commit("setModalData", payload);
  },
  setReplyData({commit}, data) {    
    commit("setReplyPostData", data);
  },
  setQuoteData({commit}, data) {
    commit("setQuotePostData", data);
  },
};
